export enum BadgeImageBackgroundColors {
    USER = "#009fba",
    NEW = "#e29933",
    DEPRECATED = "#777"
}

export enum BadgeImageLabel {
    USER = 'Meu',
    NEW = "Novo",
    DEPRECATED = "Não Comercializado"
}